<div class="padding-20" id="actionTypeMenu" *ngIf="show.form">
    <br />
    <br />
    <div class="ui-g mt-4">
        <div class="ui-g-4">

            <br />
            <div class="mt-4">
                <app-form-fields #clienti_destinati_promo data-testid="clienti_destinati_promo" [readOnly]="readOnly"
                    [fieldSchema]="formSchema.form.clienti_destinati_promo"
                    (fieldModelChange)="onChangeCustomerPromo($event)" [disabled]="readOnly"></app-form-fields>

            </div>

        </div>

        <div class="ui-g-5" style="margin-top:30px">
            <span class="title">{{ 'campaign.coupon_generation_method' | translate }}</span><span
                class="asterix">*</span>
            <br />
            <!--<span *ngIf="generationChoiseNull" class="danger-label">Perfavore selezionare un valore</span>-->
            <br />
            <br />
            <div class="mt-4 c3_staticDynamicContainer">
                <div class="c3_genCoupon ">

                    <div class="c3_gen" [ngStyle]="{'width': '50%' }"
                        [ngClass]="{'genActive': fieldModel.generationCoupon == srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code}"
                        (click)="onClickGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code)">
                        {{srvCampaign3.tipoAzioneStaticoDinamico.STATIC.description}}</div>
                    <div class="c3_gen" [ngStyle]="{'width': '50%' }"
                        [ngClass]="{'genActive': fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code}"
                        (click)="onClickGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code)">
                        {{srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.description}}</div>
                    <div class="clear_fix"></div>
                </div>
            </div>

        </div>

        <div class="ui-g-3">

        </div>
    </div>
    <div class="ui-g">

        <div class="ui-g-4 mt-5">


            <br />
            <div class="mt-4">
                <app-form-fields #tipo_attuazione_promo data-testid="tipo_attuazione_promo" [readOnly]="readOnly"
                    [fieldSchema]="formSchema.form.tipo_attuazione_promo" (fieldModelChange)="onChangeTipoPromo($event)"
                    [disabled]="readOnly"></app-form-fields>

            </div>
        </div>
    </div>


// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-action-type/message-3-action-type.component.html